import "./MobileMenu.scss";

import * as PropTypes from "prop-types";

import * as React from "react";
import { ListGroup } from "react-bootstrap";
import { Link } from "react-router";
import { FormattedMessage } from "react-intl";
import { connect } from "shared/src/stores/storeConnect";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import FilterStoreUtil from "../globalheader/store/FilterStoreUtil";
import MobileBrowsing from "./MobileBrowsing";
import MobileNavigationActions from "../../../actions/MobileNavigationActions";
import StoreInfoAndSelection from "../../general/globalheader/store/StoreInfoAndSelection";
import DeliveryAddressSelection from "../../general/globalheader/store/DeliveryAddressSelection";
import Customer from "shared/src/types/customer/Customer";
import * as UrlUtil from "../../../api/UrlUtil";
import { NavigationMenu } from "../../../datatypes/NavigationMenu";
import TrackedLink from "../TrackedLink";
import MENU_STATE from "./MenuState";
import { MenuItem } from "../../../datatypes/MenuItem";
import NavigationMenuStore from "../../../stores/NavigationMenuStore";
import StoreDataStore from "../../../stores/StoreDataStore";
import CustomerStore from "../../../stores/CustomerStore";
import { StoreType } from "../../../datatypes/Store";
import SessionStore, { isTier12Customer } from "shared/src/stores/SessionStore";
import MobileNavigationHistoryStore from "../../../stores/MobileNavigationHistoryStore";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import * as GlobalHeaderUtil from "../../../utils/GlobalHeaderUtil";
import { getComponentByName } from "shared/src/components/LazyWrapper";
const IdamCompatibleLogoutLink = getComponentByName("cia_ui/IdamCompatibleLogoutLink");

type Props = {
    menuState: string;
    currentPath: Array<string>;
    store: StoreType | null | undefined;
    transitionName: string;
    loggedIn: boolean;
    isTier12Customer: boolean;
    customer: Customer | null | undefined;
    navigationMenu: NavigationMenu;
};

class DisconnectedMobileMenu extends React.Component<Props> {
    static contextTypes = {
        router: PropTypes.object
    };

    getContentID() {
        const menuState = this.props.menuState || "";
        if (menuState === MENU_STATE.ASSORTMENT || menuState === MENU_STATE.SITECORE) {
            const categoryPath = this.props.currentPath?.join(",") ?? "";
            return menuState + categoryPath;
        } else {
            return menuState;
        }
    }

    renderLoginLogoutButton() {
        if (this.props.loggedIn) {
            return (
                <IdamCompatibleLogoutLink
                    i18nKey="EX_LOGOUT_IN_HEADER"
                    className="list-group-item list-group-item-leaf"
                />
            );
        } else {
            const location = this.context.router.getCurrentLocation();
            const pathName = UrlUtil.getRelativePathForRedirectAfterLogin(location);
            return [
                this.renderLink({ pathname: pathName, search: location.search }, "EX_LOGIN_IN_HEADER"),
                CountryUtil.getOptionalConfig().signupLink &&
                    this.renderLink(
                        { pathname: CountryUtil.getOptionalConfig().signupLink, search: "" },
                        "EX_REGISTER_IN_HEADER"
                    )
            ];
        }
    }

    renderLink(
        link: {
            pathname: string;
            search: string;
        },
        msgID: string
    ) {
        return (
            <TrackedLink
                key={msgID}
                from="MobileMenu"
                to={link}
                className="list-group-item list-group-item-leaf"
                onClick={MobileNavigationActions.CloseMobileMenu}>
                <FormattedMessage id={msgID} />
            </TrackedLink>
        );
    }

    isCurrentCustomerFsdCustomer() {
        const customer = this.props.customer;
        if (customer && customer.validForFsd) {
            return true;
        }
        return false;
    }

    renderNavigationMenuItem(item: MenuItem) {
        if (item.relativeURL) {
            return (
                <Link
                    key={item.id}
                    to={item.relativeURL}
                    className="list-group-item list-group-item-leaf"
                    onClick={MobileNavigationActions.CloseMobileMenu}>
                    {item.name}
                </Link>
            );
        } else if (item.absoluteURL) {
            return (
                <a
                    key={item.id}
                    href={item.absoluteURL}
                    className="list-group-item list-group-item-leaf"
                    onClick={MobileNavigationActions.CloseMobileMenu}>
                    {item.name}
                </a>
            );
        } else {
            return (
                <a
                    key={item.id}
                    className="list-group-item list-group-item-branch"
                    onClick={() => MobileNavigationActions.ChangeState(item.id, true)}>
                    {item.name}
                </a>
            );
        }
    }

    render() {
        const itemsBottom = this.props.navigationMenu?.shop ?? null;
        const itemsTop = this.props.navigationMenu?.personal ?? null;

        const loginLogoutButton = this.renderLoginLogoutButton();
        let pageContent = null as any | null;
        if (this.props.menuState === MENU_STATE.START) {
            pageContent = (
                <ListGroup>
                    <StoreMenuItems isCurrentCustomerFsdCustomer={this.isCurrentCustomerFsdCustomer()} />
                    {this.props.loggedIn && !this.props.isTier12Customer && (
                        <Link
                            key="portal"
                            to="/portal"
                            className="list-group-item list-group-item-leaf"
                            onClick={MobileNavigationActions.CloseMobileMenu}>
                            <i className="icon-big-mobile-user icon-2x" />
                            <FormattedMessage id="EX_MY_ACCOUNT_LINK" />
                        </Link>
                    )}
                    {this.props.loggedIn && !this.props.isTier12Customer && CountryUtil.getCountry() === "DE" && (
                        <a
                            key="mymetro"
                            href="https://www.metro.de/my-metro/account-settings"
                            className="list-group-item list-group-item-leaf"
                            onClick={MobileNavigationActions.CloseMobileMenu}>
                            Meine Seite
                        </a>
                    )}
                    {this.props.navigationMenu &&
                        !this.props.isTier12Customer &&
                        (itemsTop ?? []).map((item) => {
                            return this.renderNavigationMenuItem(item);
                        })}
                    {this.props.navigationMenu &&
                        (itemsBottom ?? []).map((item) => {
                            return this.renderNavigationMenuItem(item);
                        })}
                    {loginLogoutButton}
                </ListGroup>
            );
        } else if (this.props.menuState === MENU_STATE.MYSTORE) {
            pageContent = (
                <div>
                    <ListGroup>
                        <a
                            className="list-group-item list-group-item-header list-group-item-back"
                            onClick={() => MobileNavigationActions.ChangeState("start", false)}>
                            <h1>
                                <FormattedMessage id="EX_MOBILE_MY_METRO_STORE" />
                            </h1>
                        </a>
                    </ListGroup>
                    <div className="ex-store-selection-mobile">
                        <StoreInfoAndSelection
                            store={this.props.store}
                            onStoreSelect={MobileNavigationActions.CloseMobileMenu}
                            hideTitle
                            inMobileMenu
                            deliveryAddresses={FilterStoreUtil.getCustomerDeliveryAddresses(this.props.customer)}
                        />
                    </div>
                </div>
            );
        } else if (this.props.menuState === MENU_STATE.MYADDRESSES) {
            pageContent = (
                <div>
                    <ListGroup>
                        <a
                            className="list-group-item list-group-item-header list-group-item-back"
                            onClick={() => MobileNavigationActions.ChangeState("start", false)}>
                            <h1>
                                <FormattedMessage id="EX_MOBILE_MY_DELIVERY_ADDRESS" />
                            </h1>
                        </a>
                    </ListGroup>
                    <DeliveryAddressSelection onAddressSelect={MobileNavigationActions.CloseMobileMenu} hideTitle />
                </div>
            );
        } else {
            const menuItems = [...new Set([...itemsBottom, ...itemsTop])];
            const menuItem = menuItems?.find((a) => a.id === this.props.menuState);
            pageContent = menuItem ? (
                <ListGroup>
                    <MobileBrowsing
                        items={menuItem.children}
                        headerId={menuItem.name}
                        currentPath={this.props.currentPath}
                    />
                </ListGroup>
            ) : null;
        }

        const contentID = this.getContentID();
        pageContent = pageContent ? (
            <div className="mfcss_animated-page" key={contentID}>
                <div className="mfcss_mobile-navigation">{pageContent}</div>
            </div>
        ) : null;

        return (
            <div className="mfcss_mobile-navigation-overlay" style={{ zIndex: 10 }}>
                <div className="mfcss_animated-page-container">
                    <ReactCSSTransitionGroup
                        transitionName={this.props.transitionName}
                        transitionLeave={false}
                        transitionEnterTimeout={0}
                        transitionLeaveTimeout={0}>
                        {pageContent}
                    </ReactCSSTransitionGroup>
                </div>
            </div>
        );
    }
}

function goToMyStore() {
    MobileNavigationActions.ChangeState(MENU_STATE.MYSTORE, true);
}
function goToDeliveryAddressSelection() {
    MobileNavigationActions.ChangeState(MENU_STATE.MYADDRESSES, true);
}

export function StoreMenuItems(props: { isCurrentCustomerFsdCustomer: boolean }) {
    const storeSelector = !GlobalHeaderUtil.shouldShowMetroXStoreSelector() && CountryUtil.isMarioCountry() && (
        <a className="list-group-item list-group-item-leaf" onClick={goToMyStore}>
            <i className="icon-big-mobile-location icon-2x" />
            <FormattedMessage id="EX_MOBILE_MY_METRO_STORE" />
        </a>
    );
    return (
        <>
            {props.isCurrentCustomerFsdCustomer && (
                <a className="list-group-item list-group-item-leaf" onClick={goToDeliveryAddressSelection}>
                    <i className="icon-big-delivery-address icon-2x" />
                    <FormattedMessage id="EX_MOBILE_MY_METRO_ADDRESSES" />
                </a>
            )}
            {storeSelector}
        </>
    );
}

export const MobileMenu = connect(
    {
        stores: [
            [
                SessionStore,
                (s: typeof SessionStore) => ({
                    loggedIn: s.getInitialState().loggedIn,
                    isTier12Customer: isTier12Customer()
                })
            ],
            [MobileNavigationHistoryStore, ["menuState", "currentPath", "transitionName"]],
            [
                StoreDataStore,
                (storeData: typeof StoreDataStore) => ({
                    store: storeData.getCurrentStore()
                })
            ],
            [
                CustomerStore,
                (s: typeof CustomerStore) => ({
                    customer: s.getCustomer()
                })
            ],
            [
                NavigationMenuStore,
                (store: typeof NavigationMenuStore) => ({
                    navigationMenu: store.getNavigationMenu()?.navigationMenu
                })
            ]
        ]
    },
    DisconnectedMobileMenu
);
